import {
  TimeBlockAbsenceModel,
  TimeBlockProjectModel,
} from '../../../../core/models/timeblock/time-block.model';
import { TimeBlockDurationCalculationService } from '../../../../features/calendar/components/time-block/calculation/duration/time-block-duration-calculation.service';
import { ITimeBlockComponentItem } from '../../../../features/calendar/components/time-block/types/time-block-component-item-types';
import { TimeBlockListEntry } from '../time-enty-list-types';

export class TimeEntryConverter {
  public static toTimeBlockListEntry(timeBlock: ITimeBlockComponentItem): TimeBlockListEntry {
    const timeBlockModel = timeBlock.timeBlockModel;
    return {
      id: timeBlockModel.id,
      from: timeBlockModel.start,
      to: timeBlockModel.end,
      project: timeBlockModel instanceof TimeBlockProjectModel ? timeBlockModel.project.name : null,
      task: timeBlockModel instanceof TimeBlockProjectModel ? timeBlockModel.task.name : null,
      description: timeBlockModel.description,
      source: timeBlockModel.source,
      reason: timeBlockModel instanceof TimeBlockAbsenceModel ? timeBlockModel.reason.name : null,
      workingTime:
        TimeBlockDurationCalculationService.calculateTimeBlockDurationWithinDay(timeBlockModel),
      isActive: timeBlockModel.isActive,
      contentType: timeBlock.timeBlockContentType,
      originalTimeBlockModel: timeBlockModel,
    };
  }
}
